import api from "./axios";

export const getPushConfiguration = () => api.get("/push/config");

export const getPushSubscriptions = () => api.get("/push/subscriptions");

export const createPushSubscription = (payload) =>
  api.post("/push/subscriptions", payload);

export const unsubscribePushEndpoint = (endpoint) =>
  api.post("/push/subscriptions/unsubscribe", { endpoint });

export const disablePushSubscription = (subscriptionPublicId) =>
  api.delete(`/push/subscriptions/${subscriptionPublicId}`);

export const sendTestPushNotification = () => api.post("/push/test");
